import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';





class AlgorithmOptions extends Component {
  render() {
    return (
      <div className='App'>
        <img className='logo' src={logo}></img>
        <br />
        <div>
          Welcome to MAEJO UNIVERSITY's Saving Cooperative Blockchain Tokens Authentication System...
        </div>
        <br />
        <div><Link to='/loginoptions'>HS256</Link></div>
        <br />
        <div><Link to='/loginoptions2'>RS256</Link></div>

        <br />
        <div>Powered by</div>
        <img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default AlgorithmOptions;
